import { t } from 'utils/i18n.js'

export const HIGHCHARTS_THEME = {
  colors: ['#2563eb', '#10b981', '#8b5cf6', '#f59e0b', '#ef4444', '#06b6d4', '#ec4899'],
  chart: {
    backgroundColor: 'transparent',
    style: { fontFamily: 'ui-sans-serif, system-ui, -apple-system, sans-serif' },
  },
  title:    { style: { display: 'none' } },
  subtitle: { style: { display: 'none' } },
  xAxis: {
    gridLineColor: '#f3f4f6',
    lineColor:     '#e5e7eb',
    tickColor:     '#e5e7eb',
    labels: { style: { color: '#6b7280', fontSize: '11px' } },
  },
  yAxis: {
    gridLineColor: '#f3f4f6',
    labels: { style: { color: '#6b7280', fontSize: '11px' } },
    title: { text: null },
  },
  legend: {
    itemStyle: { color: '#374151', fontWeight: '500', fontSize: '12px' },
    itemHoverStyle: { color: '#111827' },
  },
  tooltip: {
    backgroundColor: '#1f2937',
    borderColor:     '#374151',
    borderRadius:    8,
    style: { color: '#f9fafb', fontSize: '12px' },
    shadow: false,
  },
  plotOptions: {
    series: { animation: { duration: 300 } },
  },
  credits: { enabled: false },
}

// The words Highcharts shows or reads out itself: the export menu, "Reset zoom" and the main screen reader
// sentences. They come from app.charts.*, so the charts follow the language of the page. The long tail of
// screen reader summaries (lang.accessibility.series..., axis and point descriptions) is still Highcharts' own
// English; see docs/localization.md.
export function highchartsLang() {
  return {
    loading: t('app.charts.loading'),
    resetZoom: t('app.charts.reset_zoom'),
    resetZoomTitle: t('app.charts.reset_zoom_title'),
    viewFullscreen: t('app.charts.view_fullscreen'),
    exitFullscreen: t('app.charts.exit_fullscreen'),
    printChart: t('app.charts.print_chart'),
    downloadPNG: t('app.charts.download_png'),
    downloadJPEG: t('app.charts.download_jpeg'),
    downloadPDF: t('app.charts.download_pdf'),
    downloadSVG: t('app.charts.download_svg'),
    contextButtonTitle: t('app.charts.context_button_title'),
    zoomIn: t('app.charts.zoom_in'),
    zoomOut: t('app.charts.zoom_out'),
    accessibility: {
      defaultChartTitle: t('app.charts.default_title'),
      chartContainerLabel: t('app.charts.container_label'),
      screenReaderSection: { endOfChartMarker: t('app.charts.end_marker') },
      exporting: { chartMenuLabel: t('app.charts.menu_label'), menuButtonLabel: t('app.charts.menu_button_label') },
      legend: { legendLabel: t('app.charts.legend_label'), legendLabelNoTitle: t('app.charts.legend_label_no_title') },
    },
  }
}
